











































































import { ImportApi } from '@/api/import';
import addDataImportDialog from '@/components/data/data-import/add-data-import-dialog.vue';
import dataImportsTable from '@/components/data/data-import/data-imports-table.vue';
import viewDataImportDialog from '@/components/data/data-import/view-data-import-dialog.vue';
import loading from '@/components/loading.vue';
import { DataImportFile } from '@/shared/data-import-file';
import { PartnerPractice } from '@/shared/partner-practice';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const importModule = namespace('import');
const partnerPracticesModule = namespace('partnerPractices');
const typesModule = namespace('types');

const importApi = new ImportApi();

@Component({
    components: {
        addDataImportDialog,
        dataImportsTable,
        viewDataImportDialog,
        loading,
    },
})
export default class DataImports extends Vue {
    @importModule.Getter('dataImportFiles') private dataImportFiles!: Array<DataImportFile>;
    @importModule.Getter('totalDataImportFiles') private totalDataImportFiles!: number;

    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;

    private isLoading: boolean = false;
    private currentPage: number = 1;
    private pageSize: number = 25;
    private typeFilter: number | null = null;
    private partnerPracticeFilter: string | null = null;
    private statusFilter: number | null = null;
    private showAddDataImportDialog: boolean = false;
    private showViewDataImportDialog: boolean = false;
    private selectedDataImportFile: DataImportFile | null = null;

    private dataImportFileTypes: Array<{ id: number, value: string }> = [
        { id: 0, value: 'New Data' },
        { id: 1, value: 'Cleansed Data' },
        { id: 2, value: 'Pipeline Data' },
    ];

    private dataImportFileStatuses: Array<{ id: number, value: string }> = [
        { id: 0, value: 'Pending' },
        { id: 1, value: 'In Progress' },
        { id: 2, value: 'Failed' },
        { id: 3, value: 'Succeeded' },
    ];

    private async loadDataImportFilesAsync(): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch('import/setDataImportFileFilters', {
            page: this.currentPage,
            pageSize: this.pageSize,
            type: this.typeFilter,
            partnerPracticeId: this.partnerPracticeFilter,
            status: this.statusFilter,
        });

        await this.$store.dispatch('import/loadDataImportFilesAsync');

        this.isLoading = false;
    }

    private async onFilterAsync(): Promise<void> {
        this.currentPage = 1;
        await this.loadDataImportFilesAsync();
    }

    private async onPageChangedAsync(page: number): Promise<void> {
        this.currentPage = page;
        await this.loadDataImportFilesAsync();
    }

    private async onDownloadValidationFileAsync(dataImportFile: DataImportFile): Promise<void> {
        const response = await importApi.getDataImportValidationFileAsync(dataImportFile.id);

        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.rel = 'noopener';
        link.href = window.URL.createObjectURL(blob);
        link.download = `${dataImportFile.outputFilename}`;
        link.target = '_blank';
        link.click();
        window.URL.revokeObjectURL(link.href);
    }

    private async onDataImportFileUploadedAsync(filename: string): Promise<void> {
        this.$snackbar.open({ message: `Data import file '${filename}' has been successfully uploaded and added to the import queue.`, type: 'is-success' });

        this.onCancel();
        await this.loadDataImportFilesAsync();
    }

    private onClearFilters(): void {
        this.typeFilter = null;
        this.partnerPracticeFilter = null;
        this.statusFilter = null;
    }

    private onUploadFile(): void {
        this.showAddDataImportDialog = true;
    }

    private onViewDataImport(dataImportFile: DataImportFile): void {
        this.selectedDataImportFile = { ...dataImportFile };
        this.showViewDataImportDialog = true;
    }

    private onCancel(): void {
        this.selectedDataImportFile = null;
        this.showAddDataImportDialog = false;
        this.showViewDataImportDialog = false;
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await Promise.all([
            this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`),
            this.$store.dispatch(`import/resetDataImportFiles`),
            this.$store.dispatch(`types/loadPartnerPracticeTypesAsync`),
            this.$store.dispatch(`users/loadAllUsersAsync`),
        ]);

        await this.loadDataImportFilesAsync();

        this.isLoading = false;
    }
}
